import {
  APGLUserProfile,
  TechDomainExperience,
  AWSServiceExperience,
  TechDomainDisplayNames,
} from '@amzn/awscat-pattern-library-service-model';
import { awsServiceDisplayNames } from '../utils/DisplayNames';
import { displayJoinExperience } from './APGLUserProfileUtils';

export const namesCol = {
  cell: (c: APGLUserProfile) => c.name,
  header: 'Name',
  id: 'name',
  sortingField: 'name',
};

export const typesCol = {
  cell: (i: APGLUserProfile) => i.type,
  header: 'Type',
  id: 'type',
};

export const techDomainsCol = {
  cell: (c: APGLUserProfile) => {
    const { techDomains } = c;
    return displayJoinExperience(techDomains, (techDomain) =>
      // @ts-expect-error TS2322 - strict migration
      TechDomainDisplayNames.get((techDomain as TechDomainExperience).techDomain),
    );
  },
  header: 'Relevant domain expertise',
  id: 'techDomains',
};

export const awsServicesCol = {
  cell: (c: APGLUserProfile) => {
    const { awsServices } = c;
    return displayJoinExperience(awsServices, (awsService) =>
      // @ts-expect-error TS2322 - strict migration
      awsServiceDisplayNames.get((awsService as AWSServiceExperience).awsService),
    );
  },
  header: 'AWS service expertise',
  id: 'awsServices',
};

export const reviewsCompletedCol = {
  cell: (c: APGLUserProfile) => c.totalReviewedContent,
  header: 'Reviews completed',
  id: 'totalReviewedContent',
  sortingField: 'totalReviewedContent',
};

export const reviewsPendingAcceptanceCol = {
  cell: (c: APGLUserProfile) => c.reviewsPendingAcceptance,
  header: 'Reviews pending acceptance',
  id: 'reviewsPendingAcceptance',
  sortingField: 'reviewsPendingAcceptance',
};

export const reviewsInProgressCol = {
  cell: (c: APGLUserProfile) => c.reviewsInProgress,
  header: 'Reviews in progress',
  id: 'reviewsInProgress',
  sortingField: 'reviewsInProgress',
};
